"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Header.module.css"));
function Header(props) {
    var children = props.children, classNames = props.classNames;
    return (React.createElement("div", { className: styles.headerWrap + " " + (classNames || "") },
        React.createElement("div", { className: styles.headerTitleWrap }, children)));
}
exports.default = Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYmVsbHVzL0Vucm9sbG1lbnRBZ3JlZW1lbnRGb3JtL3BhcnRzL1NlY3Rpb24xL0hlYWRlci9IZWFkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwwREFBNkM7QUFFN0MsU0FBd0IsTUFBTSxDQUFDLEtBQUs7SUFDekIsSUFBQSx5QkFBUSxFQUFFLDZCQUFVLENBQVM7SUFFcEMsT0FBTyxDQUNILDZCQUFLLFNBQVMsRUFBSyxNQUFNLENBQUMsVUFBVSxVQUFJLFVBQVUsSUFBSSxFQUFFLENBQUU7UUFDdEQsNkJBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxlQUFlLElBQUcsUUFBUSxDQUFPLENBQ3RELENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFSRCx5QkFRQyJ9